import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

var _dec, _class, _class2, _temp;

import Types from 'prop-types';
import React, { Component } from 'react';
import { styled, StyleSheet } from '@rexlabs/styling';
import { OptionPropType } from '../utils/custom-prop-types';
var SelectValue = (_dec = styled(StyleSheet({
  container: {
    backgroundColor: 'transparent'
  }
})), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  _inherits(SelectValue, _Component);

  function SelectValue() {
    _classCallCheck(this, SelectValue);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelectValue).apply(this, arguments));
  }

  _createClass(SelectValue, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          styles = _this$props.styles,
          option = _this$props.option,
          pluckLabel = _this$props.pluckLabel;
      return React.createElement("span", styles('container'), pluckLabel(option));
    }
  }]);

  return SelectValue;
}(Component), _defineProperty(_class2, "propTypes", {
  styles: Types.func,

  /** The data to display. */
  option: OptionPropType.isRequired,

  /** The helper for getting the 'label prop' from option. */
  pluckLabel: Types.func.isRequired
}), _temp)) || _class);
export default SelectValue;